document.addEventListener('DOMContentLoaded', () => {
	class NavigationDom {
		constructor(selector, where = document) {
			this.self = where.querySelector(selector);
			this.elems = where.querySelectorAll(selector);
		}
		each(callback) {
			this.elems.forEach((elem, index) => {
				return callback(elem, index);
			});
		}

		on(event, callback) {
			this.elems.forEach((elem, index) => {
				elem.addEventListener(event, (evt) => {
					return callback(elem, index, evt);
				});
			});
		}
	}

	class mobileNavigation {
		constructor(menuClass) {
			this.menuParent = new NavigationDom(menuClass);

			this.init();
		}

		init() {
			if (!this.menuParent.self) return;

			this.selectMainMenu();
			this.closeMobileWrapper();
		}

		selectMainMenu() {
			this.menuParent.each((menu) => {
				const menuHeader = new NavigationDom('.custom_mobile__nav-header .custom-site-nav_item', menu);
				const menuBody = new NavigationDom('.custom_mobile__nav-body .custom-site-nav_item', menu);
				const menuItems = new NavigationDom('.custom-site-nav-submenu__item');
				const fixedMenu = new NavigationDom('.custom_mobile__fixed-block', menu);

				menuHeader.on('click', (item, index) => {
					menuHeader.each((elem) => elem.setAttribute('data-show', false));
					menuBody.each((elem) => elem.setAttribute('data-show', false));

					item.setAttribute('data-show', true);
					menuBody.elems[index].setAttribute('data-show', true);

					menuItems.each((elem) => {
						elem.setAttribute('data-show', false);
						elem.classList.remove('hide');
					});

					fixedMenu.self.style.marginTop = '';
				});

				this.initMenuThirdLevel(menuBody);
			});
		}

		closeMobileWrapper() {
			const mobileWrapper = new NavigationDom('.mobile-nav-wrapper');
			const body = new NavigationDom('body');
			const iconClose = new NavigationDom('.custom-icon-close');
			const iconOpen = new NavigationDom('.custom-icon-menu');

			mobileWrapper.on('click', (item, index, evt) => {
				const target = evt.target;

				if (target && target.classList.contains('mobile-nav-wrapper')) {
					body.each((item) => item.classList.remove('no-scroll'));
					item.classList.remove('is-shown');
					item.firstElementChild.classList.remove('is-shown');

					iconClose.each((item) => item.classList.toggle('hide'));
					iconOpen.each((item) => item.classList.toggle('hide'));
				}
			});
		}

		initMenuThirdLevel(menuBody) {
			if (!menuBody.self) return;

			menuBody.each((elem) => {
				const arrows = new NavigationDom('.custom-site-nav-submenu__item', elem);

				arrows.on('click', (arrow, index, evt) => {
					if (
						arrow.getAttribute('data-show') === 'false' &&
						arrow.getAttribute('data-link') === 'false' &&
						!evt.target.classList.contains('custom-site-nav-submenu-third-level_link')
					) {
						arrow.setAttribute('data-show', true);
						return this.hiddenLinks(arrows);
					} else if (
						arrow.getAttribute('data-show') === 'true' &&
						arrow.getAttribute('data-link') === 'false' &&
						!evt.target.classList.contains('custom-site-nav-submenu-third-level_link')
					) {
						arrow.setAttribute('data-show', false);
						return this.showLinks(arrows);
					}
				});
			});
		}

		hiddenLinks(arrowParent) {
			arrowParent.each((elem) => elem.classList.add('hide'));
			arrowParent.each((elem) => {
				if (elem.getAttribute('data-show') === 'true') {
					const thirdElems = new NavigationDom('.custom-site-nav-submenu_third-level', elem);
					elem.classList.remove('hide');
					const height = thirdElems.self.offsetHeight;

					this.insertHeight(height);
				}
			});
		}

		showLinks(arrowParent) {
			this.insertHeight();
			arrowParent.each((elem) => elem.classList.remove('hide'));
		}

		insertHeight(height = false) {
			this.menuParent.each((elem) => {
				const fixedMenu = new NavigationDom('.custom_mobile__fixed-block', elem);

				if (height) {
					fixedMenu.self.style.marginTop = height + 'px';
				} else {
					fixedMenu.self.style.marginTop = '';
				}
			});
		}
	}

	new mobileNavigation('.mobile-header-and-nav-wrapper');
});
